import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router'
import { KeycloakEventTypeLegacy, KeycloakService } from 'keycloak-angular'
import { Subject } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class AuthenticationService implements CanActivate {
   private readonly _cn = this.constructor.name

   licencesSubject$: Subject<string[]> = new Subject<string[]>()

   constructor(
      private router: Router,
      public keycloakAngular: KeycloakService
   ) {
      keycloakAngular.keycloakEvents$.subscribe({
         next: (e) => {
            switch (e.type) {
               case KeycloakEventTypeLegacy.OnTokenExpired:
                  this.keycloakEventLog(e.type)
                  keycloakAngular.updateToken(5)
                  break
               case KeycloakEventTypeLegacy.OnAuthSuccess:
                  this.keycloakEventLog(e.type)
                  break
               case KeycloakEventTypeLegacy.OnAuthRefreshSuccess:
                  this.keycloakEventLog(e.type)
                  this.getUserLicences().then((licenses) => this.licencesSubject$.next(licenses))
                  break
               case KeycloakEventTypeLegacy.OnAuthRefreshError:
                  this.keycloakEventLog(e.type)
                  keycloakAngular.login()
                  break
               default:
                  break
            }
         },
      })
   }

   async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
      if (!(await this.keycloakAngular.isLoggedIn())) {
         await this.keycloakAngular.login()
         return false
      }
      return true
   }

   ngOnDestroy(): void {
      this.keycloakAngular.keycloakEvents$.unsubscribe()
   }

   async getUserLicences(): Promise<string[]> {
      return this.keycloakAngular.getUserRoles(true)
   }

   logout() {
      this.keycloakAngular.logout()
   }

   private keycloakEventLog(type: KeycloakEventTypeLegacy) {
      console.log(this._cn, 'Keycloak event - Type: ' + KeycloakEventTypeLegacy[type])
   }
}
